import { render, staticRenderFns } from "./ActivityFlowCard.vue?vue&type=template&id=2bf772fa&"
import script from "./ActivityFlowCard.vue?vue&type=script&lang=js&"
export * from "./ActivityFlowCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFlowCard.vue?vue&type=style&index=0&id=2bf772fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports